import React from "react"

import { PNImage } from "@bounce/web-components"

import SafeLink from "../../../../components/Generic/SafeLink/SafeLink"
import { useBookNowUrl } from "../hooks/useBookNowUrl"
import { useSectionViewed } from "@/hooks/useSectionViewed"
import type { StoreData } from "@/libs/bounce/stores/types"

export type MapProps = {
  alt?: string
  store: StoreData
}

export const Map = ({ store, alt }: MapProps) => {
  const { sectionRef } = useSectionViewed({ name: "Map" })
  const { url: bookNowUrl } = useBookNowUrl({ store })
  return (
    <section ref={sectionRef} className="flex w-full flex-col items-center max-sm:pb-6 sm:px-6">
      <SafeLink
        href={bookNowUrl}
        data-chromatic="ignore"
        className="block max-w-fit sm:max-w-[400px] md:max-w-[500px] lg:max-w-max">
        <PNImage
          src={store.staticMapUrl}
          width={store.staticMapParams.width}
          height={store.staticMapParams.height}
          unoptimized
          loading="lazy"
          alt={alt}
          className="h-[330px] w-screen rounded-lg object-cover sm:h-full sm:w-[400px] md:w-[500px] lg:w-max"
        />
      </SafeLink>
    </section>
  )
}
